import { connect } from 'react-redux'
import { navigationEvent } from 'layers/navigation/store/operations'
import ProgramLinkButton from './component'

const mapDispatchToProps = {
  navigationEvent,
}

export default connect(null, mapDispatchToProps)(ProgramLinkButton)
